import { MinusCircleIcon, PlusCircleIcon } from "@heroicons/react/24/outline";

type DepartmentTreeProps = {
  depts: any[];
  setSelectedDepartments: React.Dispatch<React.SetStateAction<number[]>>;
  expandedNodes: Record<number, boolean>;
  toggleExpand: (nodeId: number) => void;
  handleOpenChangeParentModal: (departmentId: number) => void;
  handleOpenDeleteModal: (departmentId: number) => void;
  handleOpenCreatePage: (parentDepartmentId: number) => void;
  handleOpenEditPage: (departmentId: number) => void;
};

export const DepartmentTree = ({
  depts,
  setSelectedDepartments,
  expandedNodes,
  toggleExpand,
  handleOpenChangeParentModal,
  handleOpenDeleteModal,
  handleOpenCreatePage,
  handleOpenEditPage,
}: DepartmentTreeProps) => {
  const handleUpdateSelectedDepartments = (
    nodeId: number,
    isSelected: boolean,
  ) => {
    setSelectedDepartments((prevSelected) => {
      if (prevSelected.includes(nodeId)) {
        return prevSelected.filter((id) => id !== nodeId);
      } else {
        return [...prevSelected, nodeId];
      }
    });
  };

  const displayTree = (nodes) => {
    return (
      <ul>
        {nodes.map((node) => (
          <li key={node.id} className="ml-2">
            <div className="flex items-center justify-between gap-2">
              <div className="flex items-center gap-4 relative">
                <input
                  type="checkbox"
                  className="absolute left-0 top-1/2 -translate-y-1/2 accent-blue-600"
                  onChange={(e) =>
                    handleUpdateSelectedDepartments(node.id, e.target.checked)
                  }
                />

                <div className="pl-6">
                  {node?.children?.length >= 1 ? (
                    <div
                      className="flex items-center whitespace-nowrap cursor-pointer"
                      onClick={() => toggleExpand(node.id)}
                    >
                      {expandedNodes[node.id] ? (
                        <MinusCircleIcon className="mr-2 w-5 h-5 text-mayo-link-text hover:opacity-50" />
                      ) : (
                        <PlusCircleIcon className="mr-2 w-5 h-5 text-mayo-link-text hover:opacity-50" />
                      )}
                      <div className="underline hover:opacity-50 label-light-blue-xl">
                        [{node.display_order}] {node.name}
                      </div>
                    </div>
                  ) : (
                    <div className="flex items-center label-light-blue-xl">
                      <div className="mr-2 w-5 h-5" />[{node.display_order}]{" "}
                      {node.name}
                    </div>
                  )}
                </div>
              </div>

              <div className="flex flex-col sm:flex-row items-center gap-2">
                {node.parent != null && (
                  <button
                    className="button-small-white"
                    onClick={() => handleOpenChangeParentModal(node.id)}
                  >
                    親部署を変更
                  </button>
                )}

                <button
                  type="button"
                  className="button-small-red"
                  onClick={() => handleOpenDeleteModal(node.id)}
                >
                  削除
                </button>

                <button
                  className="button-small-white"
                  onClick={() => handleOpenCreatePage(node.id)}
                >
                  階層を追加
                </button>

                <button
                  className="button-confirm font-normal"
                  onClick={() => handleOpenEditPage(node.id)}
                >
                  編集
                </button>
              </div>
            </div>
            <div className="divider mt-2"></div>
            {node.children &&
              node.children.length > 0 &&
              expandedNodes[node.id] && (
                <div className="ml-10 mt-2">{displayTree(node.children)}</div>
              )}
          </li>
        ))}
      </ul>
    );
  };

  return <div>{displayTree(depts)}</div>;
};
